import { render } from "./DemographicsSectionDetailsEMR.vue?vue&type=template&id=7d069c9f&scoped=true"
import script from "./DemographicsSectionDetailsEMR.vue?vue&type=script&lang=js"
export * from "./DemographicsSectionDetailsEMR.vue?vue&type=script&lang=js"

import "./DemographicsSectionDetailsEMR.vue?vue&type=style&index=0&id=7d069c9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d069c9f"],['__file',"src/components/DemographicsSectionDetailsEMR.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d069c9f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d069c9f', __exports__)) {
    api.reload('7d069c9f', __exports__)
  }
  
  module.hot.accept("./DemographicsSectionDetailsEMR.vue?vue&type=template&id=7d069c9f&scoped=true", () => {
    api.rerender('7d069c9f', render)
  })

}


export default __exports__